module.exports = __webpack_public_path__ + "img/bootstrap.f873cfda.png";